<!-- header-->
<div class="padded" id="header">
    <div class="header-brand">
        <a routerLink="/" class="logo" (click)="closeMenu()"> fluin.io </a>
    </div>
    <div class="spacer"></div>
    <button
        class="menu-toggle"
        type="button"
        [attr.aria-expanded]="menuOpen()"
        aria-controls="header-nav"
        aria-label="Toggle navigation menu"
        (click)="toggleMenu()"
    >
        <span></span>
        <span></span>
        <span></span>
    </button>
    <nav id="header-nav" [class.nav-open]="menuOpen()">
        <a routerLink="/bio" routerLinkActive="active-link" (click)="closeMenu()">Bio</a>
        <a routerLink="/projects" routerLinkActive="active-link" (click)="closeMenu()">Projects</a>
        <a href="https://www.youtube.com/playlist?list=PLkZLBHjxfgssv4X0Bcw6I9O4s5XBUvX5x" (click)="closeMenu()">Talks</a>
        <social-links (click)="closeMenu()" />
    </nav>
</div>
<!-- end header-->
